import React from 'react';

function PageFooterCN(props) {
    return (
        <footer>
            <div class="container">
                <div class="footer-panel-container mb-5 narrow-invisible">
                    <div class="footer-panel-item">
                        <dl>
                            <dt>产品中心</dt>
                            <dd>
                                <a href="https://www.grapecity.com.cn/solutions/huozige" target="atarget">活字格企业级低代码开发平台</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/solutions/wyn" target="atarget">Wyn 商业智能软件</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/developer/spreadjs" target="atarget">SpreadJS 纯前端表格控件</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/developer/grapecitydocuments/excel-java" target="atarget">GcExcel 服务端表格组件</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/developer/spreadstudio" target="atarget">Spread .NET表格控件</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/developer/activereportsjs" target="atarget">ActiveReportsJS 纯前端报表控件 </a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/developer/activereports" target="atarget">ActiveReports .NET报表控件</a>
                            </dd>
                        </dl>
                    </div>
                    <div class="footer-panel-item">
                        <dl>
                            <dt>客户与案例</dt>
                            <dd>
                                <a href="https://www.grapecity.com.cn/customers" target="atarget">典型客户</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/casestudies" target="atarget">成功案例</a>
                            </dd>
                        </dl>
                    </div>
                    <div class="footer-panel-item">
                        <dl>
                            <dt>服务与资源</dt>
                            <dd>
                                <a href="https://www.grapecity.com.cn/support" target="atarget">技术支持</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/support#goumaizixun" target="atarget">购买及咨询</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/support/camps" target="atarget">新手训练营</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/support/product-training" target="atarget">产品培训</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/events/certification" target="atarget">技术认证体系</a>
                            </dd>
                            <dd>
                                <a href="https://marketplace.grapecity.com.cn" target="atarget">葡萄城市场</a>
                            </dd>
                            <dd>
                                <a href="https://gcdn.grapecity.com.cn" target="atarget">葡萄城社区</a>
                            </dd>
                        </dl>
                    </div>
                    <div class="footer-panel-item">
                        <dl>
                            <dt>伙伴与生态</dt>
                            <dd>
                                <a href="https://www.grapecity.com.cn/partner" target="atarget">合作伙伴网络</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/partner/stories" target="atarget">伙伴成功故事</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/partner/yunfan" target="atarget">云帆计划</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/partner/grow-path" target="atarget">伙伴赋能</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/news?channel=school" target="atarget">高校合作</a>
                            </dd>
                        </dl>
                    </div>
                    <div class="footer-panel-item">
                        <dl>
                            <dt>活动中心</dt>
                            <dd>
                                <a href="https://www.grapecity.com.cn/support/webinars" target="atarget">葡萄城公开课</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/events/2023-meetup" target="atarget">赋能开发者Meetup</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/events/lowcode-salon" target="atarget">低代码沙龙</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/events/2023-gc-summit" target="atarget">赋能开发者高峰论坛</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/events/hzg-cases-competition-2022" target="atarget">企业级低代码应用大赛</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/developer/seminar" target="atarget">表格技术研讨会</a>
                            </dd>
                        </dl>
                    </div>
                    <div class="footer-panel-item">
                        <dl>
                            <dt>了解葡萄城</dt>
                            <dd>
                                <a href="https://www.grapecity.com.cn/aboutus" target="atarget">关于葡萄城</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/value/culture" target="atarget">企业文化</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/aboutus/innovation" target="atarget">研发与创新</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/guochan" target="atarget">葡萄城与国产化</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/honors" target="atarget">荣誉奖项</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/career" target="atarget">加入我们</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/news" target="atarget">新闻中心</a>
                            </dd>
                            <dd>
                                <a href="https://www.grapecity.com.cn/support#tousujianyi" target="atarget">投诉建议</a>
                            </dd>
                        </dl>
                    </div>
                    <div class="footer-panel-item contact-info">
                        <dl class="medium-horizontal-layout">
                            <dt class="wide-only">联系我们</dt>
                            <dd class="contact-phone">
                                <div class="fa fa-phone"></div>400-657-6008
                            </dd>
                            <dd>
                                <div class="qrcode-container">
                                    <img data-src="https://cdn.grapecity.com.cn/website-resources/images/metalsmith/home/community_QRcode.jpg?v=202206210926" alt="葡萄城社区二维码" class="qrcode lazy entered loaded" data-ll-status="loaded" src="https://cdn.grapecity.com.cn/website-resources/images/metalsmith/home/community_QRcode.jpg?v=202206210926"/>
                                </div>
                                <p>关注“葡萄城社区”</p>
                            </dd>
                        </dl>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-12">
                        <div class="row company-and-contact">
                            <div class="col-md-3 footer-company-info">
                                <div>
                                    <img class="lazy entered loaded trademark" data-src="https://cdn.grapecity.com.cn/website-resources/images/metalsmith/home/logo_funeng.png" alt="赋能开发者" data-ll-status="loaded" src="https://cdn.grapecity.com.cn/website-resources/images/metalsmith/home/logo_funeng.png"/>
                                </div>
                                <div class="short-contact">
                                    <p class="narrow-only">联系我们：400-657-6008</p>
                                    <p>西安葡萄城软件有限公司</p>
                                    <p>专业的软件开发技术和低代码平台提供商</p>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="footer-extra-links-container">
                                    <div class="footer-extra-link-item">
                                        <span><a href="https://beian.miit.gov.cn" target="_blank">陕ICP备2020018819号</a></span>
                                    </div>
                                    <div class="footer-extra-link-item">
                                        <span><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019002000258"><img class="lazy entered loaded" data-src="https://cdn.grapecity.com.cn/website-resources/images/metalsmith/home/ghs.png" alt="国徽" data-ll-status="loaded" src="https://cdn.grapecity.com.cn/website-resources/images/metalsmith/home/ghs.png"/>陕公网安备：61019002000258</a></span>
                                    </div>
                                    <div class="footer-extra-link-item">
                                        <span><a href="https://www.grapecity.com.cn/aboutus/privacy" target="_blank">隐私政策</a></span>
        
                                    </div>
                                    <div class="footer-extra-link-item">
                                        <span><a href="https://www.grapecity.com.cn/sitemap.htm" target="_blank">网站地图</a></span>
        
                                    </div>
                                </div>
                                <div class="footer-extra-links-container">
                                    <div class="footer-extra-link-item">
                                        <span>邮箱：<a href="mailto:info.xa@grapecity.com" title="咨询">info.xa@grapecity.com</a></span>
                                    </div>
                                    <div class="footer-extra-link-item">
                                        <span>©2023 葡萄城软件，保留所有权利</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default PageFooterCN;
